var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name == 'organizationalManagement')?_c('mrc_ess_table',{attrs:{"headers":_vm.headers,"pageName":"addOrganizationalManagement","hideAddBtn":!_vm.hasBtn('add-organization-change'),"paginationOptions":_vm.options,"isLoading":_vm.loading,"slotKey":[
      'result_status',
      'change_effective',
      'change_status_uuid',
      'origin_dept_uuid',
      'new_dept_uuid' ],"items":_vm.desserts},on:{"turnPage":_vm.getlist},scopedSlots:_vm._u([{key:"search",fn:function(){return [_c('v-row',{staticClass:"d-flex justify-end",staticStyle:{"background":"white","margin":"0","border-top-right-radius":"8px","border-top-left-radius":"8px","padding":"0 16px"}},[_c('mrc_ess_advanceFilterAndSearchInput',{staticClass:"mt-4",attrs:{"systemFieldMeta":_vm.systemFieldMeta},on:{"success":function($event){return _vm.getlist({ cpage: 1 })}},model:{value:(_vm.systemSeniorQueryString),callback:function ($$v) {_vm.systemSeniorQueryString=$$v},expression:"systemSeniorQueryString"}})],1)]},proxy:true},{key:"item.change_effective",fn:function(ref){
    var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("changeDate")(item.change_effective)))])]}},{key:"item.origin_dept_uuid",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.INT(item.origin_dept_uuid))+" ")]}},{key:"item.new_dept_uuid",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.INT(item.new_dept_uuid))+" ")]}},{key:"item.change_status_uuid",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.INT(item.change_status_uuid))+" ")]}},{key:"item.result_status",fn:function(ref){
    var item = ref.item;
return [_c('mrc_ess_viewbtn',{attrs:{"is_used":item.result_status_save_value,"label":item.result_status}})]}},{key:"item.actions",fn:function(ref){
    var item = ref.item;
return [_c('menu-list',{attrs:{"list":[
          {
            name: _vm.$t('label_View'),
            show: _vm.hasBtn('view-organization-change'),
            type: 'view',
          },
          {
            name: _vm.$t('label_Edit'),
            show:
              _vm.hasBtn('edit-organization-change') &&
              item.result_status_save_value === '0',
            type: 'edit',
          },
          {
            name: _vm.$t('label_delete'),
            show:
              _vm.hasBtn('delete-organization-change') &&
              item.result_status_save_value === '0',
            type: 'del',
          } ]},on:{"handleClick":function($event){return _vm.handleClick($event, item)}},scopedSlots:_vm._u([{key:"showAction",fn:function(){return [_c('v-icon',{directives:[{name:"btnAuth",rawName:"v-btnAuth",value:([
              'view-organization-change',
              'edit-organization-change',
              'delete-organization-change' ]),expression:"[\n              'view-organization-change',\n              'edit-organization-change',\n              'delete-organization-change',\n            ]"}]},[_vm._v("mdi-dots-vertical")])]},proxy:true}],null,true)})]}}],null,false,3662343588)}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }